//#region src/components/content-controls/keep-editor-focus.ts
function e(e) {
	return (t) => {
		t.preventDefault(), e?.(t);
	};
}
//#endregion
export { e as keepEditorFocusOnMouseDown };
